var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { Thread } from 'packages/email/entities/Thread';
import { Pagination } from 'packages/core/Pagination';
import { ThreadListMetadata } from 'packages/email/entities/ThreadListMetadata';
import { EntityBuilder } from '@decahedron/entity';
var ThreadRepository = /** @class */ (function (_super) {
    __extends(ThreadRepository, _super);
    function ThreadRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entity = Thread;
        _this.url = 'api/v2/talents/:talent/threads';
        _this.resultTransformer = function (response) { return ({
            items: EntityBuilder.buildMany(_this.entity, response.data.data),
            pagination: response.data.pagination ? EntityBuilder.buildOne(Pagination, response.data.pagination) : null,
            meta: EntityBuilder.buildOne(ThreadListMetadata, response.data.meta),
        }); };
        return _this;
    }
    ThreadRepository.prototype.listForTalent = function (talentId, pagination, jobId) {
        var _this = this;
        if (jobId === void 0) { jobId = null; }
        var query = pagination.queryData;
        if (jobId) {
            query = __assign(__assign({}, query), { job_id: jobId });
        }
        return this.get(this.url, { talent: talentId }, query)
            .then(function (response) { return _this.resultTransformer(response); });
    };
    return ThreadRepository;
}(AbstractRepository));
export { ThreadRepository };
